import { Directive, ViewContainerRef, Input, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { CurrentUserService } from 'src/app/core/services/current-user.service';

@Directive({
  selector: '[hgHasEntitlements]'
})
export class HasEntitlementsDirective implements OnInit, OnDestroy {

  @Input()
  hgHasEntitlements: string;

  stop$ = new Subject();

  isVisible = false;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private currentUserService: CurrentUserService
  ) {}

  ngOnInit() {
    this.currentUserService.checkEntitlements(
      this.hgHasEntitlements.replace(/\s/g, '').split(',')
    ).then(result => {
      this.isVisible = result;

      if (this.isVisible) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainerRef.clear();
      }
    });

  }

  ngOnDestroy() {
    this.stop$.next();
  }
}
